<template>
    <div class="body">
            <p  class="font1" style="padding-top: 13vh;">问渠哪得清如许，</p>
            <p  class="font1" style="padding-top: 1vh;">为有源头活水来。</p>

            <p class="font2" style="padding-top: 2vh;">2023年富学宝典上热门课程推荐：</p>
            <div style="width: 80%;margin: 0 auto;margin-top: 3vh;">
                <ul>
                    <li @click="redirectToBook(0)">{{this.book[0].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                    <li @click="redirectToBook(1)">{{this.book[1].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                    <li @click="redirectToBook(2)">{{this.book[2].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                    <li @click="redirectToBook(3)">{{this.book[3].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                    <li @click="redirectToBook(4)">{{this.book[4].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                    <li @click="redirectToBook(5)">{{this.book[5].Name}}&nbsp;&nbsp;<i class="fa fa-arrow-right fa-lg"></i></li>
                </ul>
            </div>
            <p class="font1" style="color: #953b5d;">{{ ReportData.textLab.text }}</p>
    </div>
</template>


<script>

export default {
      props: ["ReportData"],
      components:{},
      data() {
        return {
           book:''
        }
      },
      created(){
      this.book=JSON.parse(this.ReportData.recommend)
    //   console.log(book,'书');
      },
      methods:{
        redirectToBook(id){
            const book=this.book[id]
            // const url=book.link
            const view={
                clickCourseName:book.Name,
                clickCourseLink:book.link
            }
            this.$emit('redirectToBook',view)  
        }
      }
    }
</script>
  
<style scoped>
.body {
    background: url("../../assets/24January/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24January/logo2.png") right  top  no-repeat,
                url("../../assets/24January/bg6.jpg")  no-repeat;
    background-size: 17% 8%,117px 50px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    /* text-align: center; */
}
li {
    align-items: center;
    margin-bottom: 8px; /* 可调整列表项之间的间距 */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 80%;
    margin: 0 auto;
    /* text-align: center; */
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 20px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 30px;
    font-weight: bold;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #953b5d;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

</style>